<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  > 
<v-row>
  <v-col>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      color="primary"
    ></v-progress-linear>
  </v-col>
</v-row>
<sequential-entrance fromTop>

<v-row class="hidden-md-and-down"> 
  <v-col v-for="button in menuforstatus" :key="button" justify-space-around>
    <base-material-card
      v-if="!loading"
      :color="button.color"
      :icon="button.icon"
      inline
      link
      :to="gettopurl(button.nav)"
    >
      <template v-slot:after-heading>
        <div class="display-1 font-weight-light">
          {{button.text}}
        </div>
      </template>
    </base-material-card> 
 
  </v-col>
</v-row> 
<v-row>
  <v-col>
    <base-material-card
      v-if="!loading"
      color="primary"
      icon="mdi-bank"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Balance Site {{id}} Safe ID {{safes[0].crypto_idnum}}
        </div>

          <div class="display-2 font-weight-light">Current Total: {{currentsum}}</div>
    
      </template>
      <v-row>
        <v-spacer></v-spacer>
        
        <v-btn color="warning" to="/reports" >Return</v-btn>
      </v-row>

      <apexchart type="bar" height="370" :options="chartOptions" :series="safesums" v-if="!calculating"></apexchart>

      <v-divider class="mt-3" />

  <v-data-table
    :headers="headers"
    :items="safe_data"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Current Note Values</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <div class="display-2 font-weight-light">
        Sorry, no messages to display for Smart Safe ID {{id}}
      </div>
      <br>
    </template>
  </v-data-table>  
    </base-material-card>

    <div class="py-3" />

  </v-col>
</v-row>
   </sequential-entrance>

  </v-container>
</template>

<script>
  const axios = require('axios')

  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    props: ['id'],
    name: 'CashBalance',

    data () {
      return {
        calculating: true,
        options: {
          chart: {
            sparkline: {
              enabled: true
            }
          },
          colors: ['#00aedb'],
          stroke: {
            width: 2,
            curve: 'smooth'
          },
          fill: {
            gradient: {
              shade: 'light',
              type: 'diagonal1',
              shadeIntensity: 0.5,
              gradientToColors: ['#3BA22F'],
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 90, 100],
              colorStops: []
            }
          },
          xaxis: {
            crosshairs: {
              width: 1
            }
          },
          yaxis: {
            min: 0
          },
          title: {
            text: '$135,965',
            offsetX: 0,
            style: {
              fontSize: '24px',
              cssClass: 'apexcharts-yaxis-title'
            }
          },
          subtitle: {
            text: 'Revenue',
            offsetX: 0,
            style: {
              fontSize: '14px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        },
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Cash in',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value
              }
            }
          },
          xaxis: {
            categories: []
          }
        },
        series: [{
          name: 'cashinbyday',
          data: []
        }],
        headers: [
          { text: 'Ones', value: 'ones', align: 'center' },
          { text: 'Fives', value: 'fives', align: 'center' },
          { text: 'Tens', value: 'tens', align: 'center' },
          { text: 'Twenties', value: 'twenties', align: 'center' },
          { text: 'Fifties', value: 'fifties', align: 'center' },
          { text: 'Hundreds', value: 'hundreds', align: 'center' },
        ],
        valid: true,
        graphsums: [],
        graphdays: [],
        notetable: [],
        machinesum: 0,
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        activeBtn: 1,
        grow: true,
        cashinperunit: '',
        loading: false
      }
    },
    timers: {
      log: { time: 1000, autostart: true, repeat: true }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },  
    computed: {
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager'){
          return [  
          {
          text: 'Live View',
          value: 'live',
          icon: 'mdi-youtube-tv',
          color: 'light-blue accent-2'
          }]
        } else if (this.$store.getters.user.status === 'groupmanager'){
          return [       
          {
          text: 'Live View',
          value: 'live',
          icon: 'mdi-youtube-tv',          
          color: 'light-blue accent-2'
          },
          ]          
        } else if (this.$store.getters.user.status === 'corporate'){
          return [
          {
          text: 'Live View',
          value: 'live',
          icon: 'mdi-youtube-tv',
          color: 'light-blue accent-2'
          },
          {          
          value: 'cashin',
          text: 'Daily Volume',
          color: 'purple',
          icon: 'mdi-youtube-tv',
          },          
          ]          
        } else if (this.$store.getters.user.status === 'admin'){
          return [               
          {
          text: 'Live View',
          value: 'live',
          color: 'light-blue accent-2',
          icon: 'mdi-youtube-tv',
          nav: '/ReportLive/'
          },
          {
          text: 'Deposit Events',
          value: 'deposits',
          color: 'green',
          icon: 'mdi-account-cash-outline',  
          nav: '/ReportDeposit/'
          },        
          {      
          value: 'cashin',
          text: 'Daily Volume',
          color: 'orange',
          icon: 'mdi-calendar-multiple',
          nav: '/ReportCashin/'                
          }, 
        ]
        }      
      },
      currentsum() {
        return numeral(this.machinesum).format('$0.00')
      },
      safesums () {
        this.chartOptions.xaxis.categories = ['Ones', 'Fives', 'Tens', 'Twenties', 'Fifties', 'Hundreds']
        this.$log.debug('NOTE TABLE IS ', this.notetable)
        return [{name: 'Notes', data: [...this.notetable]}]
      },
      safe_data () {
        this.items = []
        this.machinesum = 0
        // lets cut this thing up to how we want it
        let sitedata = this.$store.getters.balancevalues
        let graphdata = []
        // get the safes
        // get the days per safe
        let ones = 0
        let fives = 0
        let tens = 0
        let twenties = 0
        let fifties = 0
        let hundreds = 0
        let sum = 0
        for (let index in sitedata) {
          sum = sum + sitedata[index].note
          let val = sitedata[index].note
          if (val === 1) {
            ones++
          }
          else if (val === 5) {
            fives++
          }
          else if (val === 10) {
            tens++
          }
          else if (val === 20) {
            twenties++
          }
          else if (val === 50) {
            fifties++
          }              
          else if (val === 100) {
            hundreds++
          }           
          


          // locationgraphdata[safeid].safes[safeid].push(safedata)
         // this.$log.debug('location data formatted ', graphdata)
         // this.graphdays = [...(graphdata.map(data => data.day))]
         // this.$log.debug('graph days array ', this.graphdays)

//          this.graphsums = [...(graphdata.map(data => data.sum))]
          //this.graphsums.reverse()

  //        this.$log.debug('graph sums array ', this.graphsums)
    //      this.chartOptions.xaxis.categories = this.graphdays
      //    this.items = graphdata.reverse()
          this.calculating = false

        }
        graphdata = []
        this.items = []
        this.$log.debug('graphdata is ', graphdata, ' items is ', this.items)
        graphdata.push({
          ones: ones,
          fives: fives,
          tens: tens,
          twenties: twenties,
          fifties: fifties,
          hundreds: hundreds,
          sum: sum
          })
        this.machinesum = sum  
        this.items = graphdata
        this.notetable = [ones, fives, tens, twenties, fifties, hundreds]
          // for each day count the note types
          // for each day get the sum of the notes
        // return this.items
        this.loading = false
        return this.items
      },
      currentsafes () {
        let oursafes = this.$store.getters.safesstatus
        this.$log.debug("SAFES ARE ", this.$store.getters.safesstatus)
        return oursafes
      },      
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
      this.loading = true
      this.graphsums = []
      this.graphdays = '',
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      // this.$store.dispatch('loadsafetransactions', this.$route.params.id)
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimebalance', this.safes)
      // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      log () {
        // this.items = this.$store.getters.cashinvalues
        // this.$log.debug('cheating ', this.items)
      },
      gettopurl(nav) {
        let url = nav + this.id
        return url
      },
      getsitemap (machineid) {
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.idnum===machineid) {
            if (value.siteunitsprofile) {
              let shop = {
                idnum: key,
                safeids: value.siteunitsprofile
              }
              this.location = shop
              this.safes = shop.safeids
              this.$store.dispatch('initrealtimebalance', this.safes)


              // now go get the data for these sites in the shop array
              // 
            }
          }
        }
      },
      getsslabel (machineid) {
        let sstranslation = [
          {
            e2c_code: 'S&S-0123710756A6B4DDEE',
            ss_code: 'S&S-00008'
          },
          {
            e2c_code: 'S&S-01234377F71ABC02EE',
            ss_code: 'S&S-00071'
          },
          {
            e2c_code: 'S&S-01237A550A4A6078EE',
            ss_code: 'S&S-00068'
          },
          {
            e2c_code: 'S&S-0123C777FFEC8C32EE',
            ss_code: 'S&S-00077'
          },
          {
            e2c_code: 'S&S-01238BDDB636B83DEE',
            ss_code: 'S&S-00080'
          },
          {
            e2c_code: 'S&S-012301FE6AF30096EE',
            ss_code: 'S&S-00083'
          },
          {
            e2c_code: 'S&S-012385C0A9F02CE9EE',
            ss_code: 'S&S-00069'
          }                               
        ]        
        let sslabel = ' '
        sslabel = sstranslation.find(element => element.e2c_code === machineid)
        let label = 'Not Listed'
        if (sslabel) {
          label = sslabel.ss_code
        }
        return label
      },
      initialize () {
        let reportdata = this.$store.getters.safetransactions

        this.items = this.$store.getters.safesstatus
      },  
      format_time (ts) {
        return moment(ts).format('MMMM Do, h:mm:ss')
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
